import { useNoticeSendSubData } from "~/services/customer/notice";

const useNoticeSend = () => {
  const { data: noticeSendSubData } = useNoticeSendSubData();
  return { noticeSendSubData };
};

export default useNoticeSend;
